import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

interface QuizzesListSkeletonProps {
  count?: number;
}

export const QuizzesListSkeleton: React.FC<QuizzesListSkeletonProps> = ({
  count = 3,
}) => {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="flex items-center gap-3 rounded-xl border border-border/50 bg-card p-4"
        >
          {/* Quiz icon skeleton */}
          <Skeleton className="h-10 w-10 shrink-0 rounded-lg" />
          
          {/* Text content */}
          <div className="flex-1 space-y-2">
            {/* Title */}
            <Skeleton className="h-4 w-3/4" />
            {/* Question count & difficulty */}
            <div className="flex gap-2">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-3 w-16" />
            </div>
          </div>
          
          {/* Action button placeholder */}
          <Skeleton className="h-8 w-8 shrink-0 rounded-md" />
        </div>
      ))}
    </div>
  );
};
